import { render } from "./Goods.vue?vue&type=template&id=1a28e64f&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=1a28e64f&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a28e64f"]])

export default __exports__